import { render, staticRenderFns } from "./life-experience-pavilion-reservation.vue?vue&type=template&id=70f6b9c2&"
import script from "./life-experience-pavilion-reservation.vue?vue&type=script&lang=js&"
export * from "./life-experience-pavilion-reservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports